// File: components/Campaigns.tsx

const Campaigns = ({ campaigns ,handleCampaignRow}) => {

 //console.log("campaign", campaigns)
  return (
    <div className="p-4 overflow-x-auto">
      <h3>Track All Campaigns</h3>
      <table className="min-w-full border-collapse bg-white rounded-xl overflow-hidden shadow-sm">
        <thead>
          <tr className="text-left text-sm text-gray-600 bg-gray-50">
            <th className="px-6 py-3">Campaign</th>
            <th className="px-6 py-3">Platform</th>
            <th className="px-6 py-3">Brand</th>
            <th className="px-6 py-3">POC Email</th>
            <th className="px-6 py-3">Contract</th>
            <th className="px-6 py-3">Invoice</th>
             <th className="px-6 py-3">Timeline</th>
          </tr>
        </thead>
        <tbody className="text-sm text-gray-700">
          {campaigns.map((row, i) => (
            <tr key={i} className="border-t">
              <td className="px-6 py-4 font-medium text-gray-900">
                {row.campaignTitle}
              </td>
              <td className="px-6 py-4">{row.platform}</td>
              <td className="px-6 py-4">{row.brandName}</td>
              <td className="px-6 py-4">{row.pocEmail}</td>
              <td className="px-6 py-4">
                {row.contract?.agreement_file ? (
                  <a
                    href={row.contract?.agreement_file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-600 hover:underline"
                  >
                    View
                  </a>
                ) : (
                  "--"
                )}
              </td>

              <td className="px-6 py-4">
                {row?.invoices[0]?.invoice_file ? (
                  <a
                    href={row?.invoices[0]?.invoice_file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-600 hover:underline"
                  >
                    View
                  </a>
                ) : (
                  "--"
                )}
              </td>
                <td className="px-6 py-4 cursor-pointer "
                onClick={()=>handleCampaignRow(row)}
                ><button className="bg-green-600 text-white px-2 py-1 rounded-full">Track</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Campaigns;
